/**
 * Utility classes using CSS variable-based design tokens.
 * No more dual light/dark classes needed — tokens auto-switch with .dark class.
 */

export const darkModeClasses = {
  // Backgrounds
  page: "bg-surface-0",
  card: "bg-surface-2",
  modal: "bg-surface-2",
  header: "bg-surface-1",
  sidebar: "bg-surface-1",

  // Borders
  border: "border-border-1",
  borderLight: "border-border-0",

  // Text
  textPrimary: "text-text-primary",
  textSecondary: "text-text-secondary",
  textMuted: "text-text-tertiary",
  textLight: "text-text-quaternary",

  // Interactive elements
  button: "bg-accent text-accent-contrast hover:brightness-[1.08]",
  buttonSecondary: "bg-surface-3 text-text-secondary border border-border-1 hover:brightness-[1.08]",
  input: "bg-surface-3 border-border-1 text-text-primary placeholder-text-quaternary",

  // Hover states
  hoverBg: "hover:bg-surface-3",
  hoverBgLight: "hover:bg-surface-4",

  // Focus states
  focus: "focus:ring-accent",
} as const;

/**
 * Combine multiple class strings
 */
export function cn(...classes: string[]): string {
  return classes.filter(Boolean).join(' ');
}

/**
 * Get common page wrapper classes
 */
export function getPageClasses(): string {
  return cn(darkModeClasses.page);
}

/**
 * Get common card classes
 */
export function getCardClasses(): string {
  return cn(
    darkModeClasses.card,
    darkModeClasses.border,
    "rounded-card",
    "shadow-card"
  );
}
